import { React, useState, useEffect, useContext } from "react";
import Button from "@mui/material/Button";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import GridNoRow from '../../../../common/GridNoRow';
import axios from "axios";
import Swal from "sweetalert2";
import LotInfoModal from "../../../../modal/PC/stock/LotInfoModal";
import LotSelectModal from "../../../../modal/PC/common/LotSelectModal";
import styled from "styled-components";
import Select from 'react-select';
import { AppContext } from '../../../../AppStore';
import Moment from 'moment';
import { useNavigate, useLocation } from "react-router-dom";
import AssignmentIcon from '@mui/icons-material/Assignment';

const LotTrackingInfo = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const appStore = useContext(AppContext);

    // 권한 및 메뉴 관련 State
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');

    // 모달 State
    const [isModalOpen, setModalOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [isSelectLotModalOpen, setSelectLotModalOpen] = useState(false);

    // 선택된 Lot 정보 State
    const [selectLotNo, setSelectLotNo] = useState('');
    const [selectLotNoStatusName, setSelectLotNoStatusName] = useState('');
    const [selectLotCreateTypeName, setSelectLotCreateTypeName] = useState('');
    const [selectLotCreateDatetime, setSelectLotCreateDatetime] = useState('');
    const [selectLotDeleteTypeName, setSelectLotDeleteTypeName] = useState('');
    const [selectLotDeleteDatetime, setSelectLotDeleteDatetime] = useState('');
    const [selectItemTypeName, setSelectItemTypeName] = useState('');
    const [selectItemDivisionName, setSelectItemDivisionName] = useState('');
    const [selectItemName, setSelectItemName] = useState('');
    const [selectItemSpec, setSelectItemSpec] = useState('');
    const [selectLotSaveName, setSelectLotSaveName] = useState('');
    const [selectLotPlanDatetime, setSelectLotPlanDatetime] = useState('');
    const [selectLotLossDatetime, setSelectLotLossDatetime] = useState('');

    // 이력(트래킹) 데이터 State 추가
    const [trackingList, setTrackingList] = useState([]);

    useEffect(() => {
        const accessList = JSON.parse(localStorage.getItem("nav"));
        
        if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
            const menuData = accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/"));
            setMenuID(menuData.menu_id);
            setMenuName(menuData.menu_name);
            setMenuUpdateExistYN(menuData.menu_update_exist_yn);
            setMenuDeleteExistYN(menuData.menu_delete_exist_yn);
            setMenuUpdateYN(menuData.menu_update_yn);
            setMenuDeleteYN(menuData.menu_delete_yn);
        } else {
            Swal.fire({
                title: '<p style="color:red">접근 권한 오류</p>',
                text: '화면에 접근 권한이 없습니다.',
                confirmButtonText: '확인',
                confirmButtonColor: '#7066e0',
                timer: 5000,
                timerProgressBar: true
            }).then(() => {
                return navigate(-1);
            });
        }
    }, [navigate]);

    useEffect(() => {
        if (String(MenuID) !== String(0) && MenuID != null) {
            handleSetting();
            handleInitSelect();
            handleView();
        }
    }, [MenuID]);

    const handleSetting = () => {};
    const handleView = () => {};
    const handleInitSelect = () => {};

    const handleInit = () => {
        setSelectLotNo('');
        setTrackingList([]);
    };

    const handleLotClick = (object) => {
        // 1. Lot 기본 정보 세팅
        setSelectLotNo(object.item_lotno || '');
        setSelectLotNoStatusName(object.item_lotno_status_name || '');
        setSelectLotCreateTypeName(object.item_lot_create_type_name || '');
        setSelectLotCreateDatetime(object.item_lot_create_datetime || '');
        setSelectLotDeleteTypeName(object.item_lot_delete_type_name || '');
        setSelectLotDeleteDatetime(object.item_lot_delete_datetime || '');
        setSelectItemTypeName(object.item_type_name || '');
        setSelectItemDivisionName(object.item_division_name || '');
        setSelectItemName(object.item_name || '');
        
        // 규격 세팅
        const formattedSpec = appStore.ITEM_FULL_SPEC_MAKE(object.item_spec, object.item_width, object.item_depth, object.item_height);
        setSelectItemSpec(formattedSpec || '');
        
        setSelectLotSaveName(object.item_lot_save_name || object.item_lot_save_warehouse_name || ''); 
        setSelectLotPlanDatetime(object.item_lot_plan_datetime || '');
        setSelectLotLossDatetime(object.item_lot_loss_datetime || '');

        // 2. 모달 닫기
        setSelectLotModalOpen(false);

        // 3. 트래킹 이력 API 호출
        axios.get('/api/p/LotTrackingInfo/List', {
            params: {
                lotno: object.item_lotno || '',
            }
        }, { withCredentials: true })
        .then((response) => {
            console.log('LotTrackingInfo List Response:', response.data);
            
            // 발생시간(log_time) 포맷팅 및 id 부여
            const formattedData = (Array.isArray(response.data) ? response.data : []).map((item, index) => ({
                ...item,
                id: index,
                log_time: item.log_time ? Moment(item.log_time).format('YYYY-MM-DD HH:mm:ss') : '-'
            }));
            
            setTrackingList(formattedData);
        })
        .catch((error) => {
            console.error(error);
            appStore.capture();
        });
    };

    return (
        <div style={{ width: '100%', display: String(MenuID) === String(0) ? 'none' : 'block' }}>
            <div className="menubox">
                <div className="menu-action">
                    <div className="menu-title">{MenuName}</div>
                </div>
                <div className="menu-keyword">
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-title">
                            Lot No
                        </div>
                        <div className="menu-keyword-sub-keyword" style={{ maxWidth: '300px' }}>
                            <input 
                                type="text" 
                                placeholder="Lot No" 
                                value={selectLotNo} 
                                name="selectLotNo" 
                                readOnly 
                                onClick={() => setSelectLotModalOpen(true)} 
                                style={{ cursor: 'pointer', backgroundColor: '#f5f5f5' }} 
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="grid" style={{ top: '143px' }}>
                {/* 조회가 안 된 상태면 grid_sub 클래스를 부여하고, 조회가 되면 없앱니다. */}
                <div className={selectLotNo ? "" : "grid_sub"} style={{ width: '100%', height: 'calc(100vh - 243px)', fontSize: '17px' }}>
                    
                    {/* 선택된 Lot 상세 정보 카드 */}
                    {selectLotNo && (
                        <InfoCard>
                            <div className="card-body">
                                <InfoItem label="품목명" value={selectItemName} />
                                <InfoItem label="규격" value={selectItemSpec} />
                                <InfoItem label="구분" value={selectItemDivisionName} />
                                <InfoItem label="현재 상태" value={selectLotNoStatusName} color="#1976d2" />
                                <InfoItem label="보관위치" value={selectLotSaveName} />
                                <InfoItem 
                                    label="생성일시" 
                                    value={selectLotCreateDatetime ? Moment(selectLotCreateDatetime).format('YYYY-MM-DD HH:mm:ss') : '-'} 
                                />
                            </div>
                        </InfoCard>
                    )}

                    {/* 이력(트래킹) DataGrid */}
                    <div className={selectLotNo ? "grid_sub" : ""} style={{ width: '100%', height: selectLotNo ? 'calc(100vh - 353px)' : '100%', marginTop: selectLotNo ? '20px' : '0' }}>
                        <DataGrid
                            className="grid_main"
                            rows={trackingList}
                            columns={[
                                { field: 'event_group', headerName: '그룹', width: 100, align: 'center', headerAlign: 'center' },
                                { 
                                    field: 'event_type', 
                                    headerName: '구분', 
                                    width: 120, 
                                    align: 'center', 
                                    headerAlign: 'center',
                                    renderCell: (params) => {
                                        const val = params.value || '';
                                        return (
                                            <b style={{ color: val.includes('완료') ? '#2e7d32' : '#ed6c02' }}>
                                                {val}
                                            </b>
                                        );
                                    }
                                },
                                { 
                                    field: 'event_detail', 
                                    headerName: '상세내용', 
                                    flex: 1, 
                                    headerAlign: 'center',
                                    renderCell: (params) => {
                                        const text = params.value || '';
                                        
                                        // 💡 [공통 헬퍼 함수] 투입/생성 버튼을 동일한 디자인으로 뽑아주는 역할
                                        const renderLotButton = (mainText, subText, type) => {
                                            const isInput = type === '투입';
                                            const color = isInput ? '#1976d2' : '#2e7d32';     // 투입은 파란색, 생성은 초록색
                                            const bgColor = isInput ? '#f1f8ff' : '#e8f5e9';

                                            return (
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', width: '100%' }}>
                                                    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                        {mainText}
                                                    </span>
                                                    <button
                                                        style={{
                                                            border: `1px solid ${color}`,
                                                            backgroundColor: bgColor,
                                                            color: color,
                                                            borderRadius: '4px',
                                                            padding: '2px 6px',
                                                            fontSize: '11px',
                                                            cursor: 'pointer',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            height: '20px',
                                                            flexShrink: 0
                                                        }}
                                                        onClick={(e) => {
                                                            e.stopPropagation(); // 행 클릭 무시
                                                            Swal.fire({
                                                                title: `<h4 style="margin:0; color:#333;">${type} Lot 목록</h4>`,
                                                                html: `
                                                                    <div style="max-height: 250px; overflow-y: auto; text-align: left; padding: 15px; background: #f8f9fa; border: 1px solid #ddd; border-radius: 4px; font-family: monospace; font-size: 14px; line-height: 1.8;">
                                                                        ${subText.split(', ').join('<br/>')}
                                                                    </div>
                                                                `,
                                                                confirmButtonText: '닫기',
                                                                confirmButtonColor: '#3D63AE'
                                                            });
                                                        }}
                                                    >
                                                        <span style={{ fontSize: '10px', marginRight: '2px' }}>🔍</span> {type}Lot
                                                    </button>
                                                </div>
                                            );
                                        };

                                        // 1. 투입 Lot 버튼 처리 (생산 완료 이벤트용)
                                        if (text.includes(' / 투입Lot: ')) {
                                            const [mainText, subText] = text.split(' / 투입Lot: ');
                                            return renderLotButton(mainText, subText, '투입');
                                        }

                                        // 2. 생성 Lot 버튼 처리 (품목 투입 이벤트용) ★ 추가된 부분
                                        if (text.includes(' / 생성Lot: ')) {
                                            const [mainText, subText] = text.split(' / 생성Lot: ');
                                            return renderLotButton(mainText, subText, '생성');
                                        }
                                        
                                        // 3. 둘 다 아닌 일반 텍스트
                                        return (
                                            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                {text}
                                            </span>
                                        );
                                    }
                                },
                                { 
                                    field: 'log_time', 
                                    headerName: '발생시간', 
                                    width: 180, 
                                    align: 'center', 
                                    headerAlign: 'center',
                                },
                                { field: 'user_name', headerName: '담당자', width: 120, align: 'center', headerAlign: 'center' },
                                { field: 'ref_number', headerName: '참조번호', width: 150, align: 'center', headerAlign: 'center' },
                            ]}
                            pageSize={10}
                            rowsPerPageOptions={[10]}
                            disableSelectionOnClick
                            slots={{
                                noRowsOverlay: GridNoRow,
                            }}
                            sx={{
                                '& .MuiDataGrid-columnHeaders': { backgroundColor: '#f8f9fa', fontWeight: 'bold' },
                                '& .MuiDataGrid-row:hover': { backgroundColor: '#f1f8ff' },
                            }}
                        />
                    </div>
                </div>
            </div>

            {/* Lot 선택 모달 */}
            {isSelectLotModalOpen && (
                <LotSelectModal
                    onClose={() => setSelectLotModalOpen(false)}
                    title={'Lot 목록'}
                    handleLotClick={handleLotClick}
                    status={'CDLP'}
                />
            )}
        </div>
    );
}

// ---------------- Styled Components ---------------- //

const InfoItem = ({ label, value, color }) => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        <span style={{ fontSize: '13px', color: '#666', fontWeight: '500' }}>{label}</span>
        <span style={{ fontSize: '16px', fontWeight: 'bold', color: color || '#333' }}>{value || '-'}</span>
    </div>
);

const InfoCard = styled.div`
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
    margin-bottom: 20px;
    overflow: hidden;

    .card-body {
        padding: 20px;
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
        gap: 24px 16px;
    }
`;

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;

export default LotTrackingInfo;